export default{
    lang:"ko",
    fontFamily:"kr-font-family",
    fontFamilyTitle:"kr-font-family-title",
    requestLang:"ko_KR",
    type: "en",
}